<template>
  <div id="chatBox">
    <iframe
      id="iframeChatBox"
      :src="chatUrl"
      :style="{ height: frameHeight + 'px' }"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'XiaoMai',
  data() {
    return {
      KEFU_NAME: '',
      ENT_ID: '12',
      frameHeight: window.innerHeight
    }
  },
  computed: {
    chatUrl() {
      if (process.env.VUE_APP_BASE_URL === 'http://43.198.73.182:8199') {
        return ``
      }
      return `https://xxx.com/chatIndex?ent_id=${this.ENT_ID}&kefu_id=${this.KEFU_NAME}&lang=cn`
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.frameHeight = window.innerHeight
    }
  }
}
</script>

<style scoped>
body {
  margin: 0;
  overflow: hidden;
}
#chatBox {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
#iframeChatBox {
  border: none;
  width: 100%;
  height: 100%;
  display: block;
}
</style>
